<template>
  <div v-if="platformPermissionsLoaded && checkPermission('loyalty.insights.userpoints') && ['explorer', 'business', 'enterprise'].includes(productLicenses.loyalty_license_tag)">
    <SmartFilters ref="smartFilters" :parent="'sm_points_updates_insights'"/>

    <CRow>
      <CCol col="12" xl="12">
        <loyaltyPointsUpdates ref="loyaltyPointsUpdates" :platformPermissions="platformPermissions" :showHeader="true" :itemsPerPage="10" :productLicenses="productLicenses" :filters="smartFilters"/>
      </CCol>
    </CRow>
  </div>
  <noPermission v-else-if="platformPermissionsLoaded" trigger="permission"/>
</template>

<script>
import axios from 'axios'
import loyaltyPointsUpdates from '@/components/loyalty/loyaltyPointsUpdates.vue'
import noPermission from '@/components/common/noPermission.vue';

import SmartFilters from '@/components/insights/common/SmartFilters.vue';

export default {
  name: 'EmployeePointsUpdates',
  components: {
    loyaltyPointsUpdates,
    noPermission,
    SmartFilters
  },
  data: () => {
    return {
      platformPermissions: [],
      platformPermissionsLoaded: false,
      productLicenses: {
        loyalty_licence_tag: null
      },
      smartFilters: []
    }
  },
  methods: {
    getPlatformPermissions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/permissions')
      .then(res => {      
        this.platformPermissions = res.data.data;
        // Update the platformPermissionsLoaded value
        this.platformPermissionsLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    checkPermission(permissionTag) {
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    }       
  },
  async mounted(){
    this.getPlatformPermissions();

    this.productLicenses = await this.fetchProduuctLicenseData();

    this.$bus.$on('sm_points_updates_insights_smart_filters_updated', (filters) => {
      this.smartFilters = filters;

      setTimeout(function() {
        this.$refs.loyaltyPointsUpdates.getUserPoints();
      }.bind(this), 250);
    });    
  },
  beforeDestroy() {
    this.$bus.$off('sm_points_updates_insights_smart_filters_updated');
  } 
}
</script>
